const AccessManagementStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '100px 0', // Consistent padding for smooth spacing
  },
  contentWrapper: {
    display: 'flex',
    width: '90%', // Prevents full width and allows natural curvature
    maxWidth: '1200px',
    borderRadius: '50px', // Fully rounded section
    overflow: 'hidden', // Ensures smooth edges
    boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.1)', // More lifted effect
  },
  leftSide: {
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    padding: '80px 60px',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '180px',
  },
  icon: {
    fontSize: '140px',
    color: '#81c241',
  },
  rightSide: {
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    padding: '80px 60px',
  },
  textContainer: {
    textAlign: 'left',
    maxWidth: '650px',
  },
  boldText: {
    fontWeight: 'bold',
    fontSize: '1.8rem',
    color: '#000',
  },
  description: {
    fontSize: '1.2rem',
    marginTop: '10px',
    lineHeight: '1.6',
    color: '#333',
  },
  list: {
    marginTop: '15px',
    paddingLeft: '15px',
  },
  listItem: {
    fontSize: '1.1rem',
    color: '#333',
  },
};

export default AccessManagementStyles;
